import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { LazyLoadEvent, SelectItem } from 'primeng';
import { ITaskFilter } from '../../interfaces/task-filter';
import { ITaskInfo } from '../../interfaces/task-info';
import { EngineiusRegionService, UserService } from '../../services';
import { InboxJobsService } from '../../services';
import { TaskService } from '../../services';
import { VmeInboxJobsService } from '../../services';
import { flatten } from '../../utils/flatten';
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'jobs-tasks-live',
  templateUrl: './jobs-tasks-live.component.html',
  styleUrls: ['./jobs-tasks-live.component.css'],
})
export class JobsTasksLiveComponent implements OnInit, OnDestroy {
  inboxType_VmeInbox = 1;
  inboxType_SupplierExistingJobs = 2;
  inboxType_CustomerInbox = 3;

  subscription: Subscription;
  taskList: any[];
  taskTypes: SelectItem[] = [this.inboxjobsService.taskTypeDefSelect];
  eregions: SelectItem[] = [this.inboxjobsService.eregionDefSelect];

  public filter: Subject<ITaskFilter>;
  public filterVal: ITaskFilter;
  public from: string;
  public to: string;
  public regNo: string;
  public msgs: any[];

  private _inboxType: number;
  private organisationTypeId: number;
  @Input('inboxType')
  set inboxType(value: number) {
    this._inboxType = value;
  }
  get inboxType(): number {
    return this._inboxType;
  }

  private _selectedTask: ITaskInfo;
  @Output() selectedTaskChange: EventEmitter<ITaskInfo>;
  @Input('selectedTask')
  set selectedTask(value: any) {
    this._selectedTask = value;
    this.selectedTaskChange.emit(value);
  }
  get selectedTask(): any {
    return this._selectedTask;
  }

  customersDefSelect: SelectItem = { label: 'All Customers', value: 0 };
  private _customers: SelectItem[] = [this.customersDefSelect];
  @Input('customers')
  set customers(value: SelectItem[]) {
    this._customers = value;
  }
  get customers(): SelectItem[] {
    return this._customers;
  }

  suppliersDefSelect: SelectItem = { label: 'All Suppliers', value: 0 };
  private _suppliers: SelectItem[] = [this.suppliersDefSelect];
  @Input('suppliers')
  set suppliers(value: SelectItem[]) {
    this._suppliers = value;
  }
  get suppliers(): SelectItem[] {
    return this._suppliers;
  }

  constructor(
    private taskService: TaskService,
    private inboxjobsService: InboxJobsService,
    private engineiusRegionService: EngineiusRegionService,
    private vmeInboxjobsService: VmeInboxJobsService,
    private userService: UserService,
  ) {
    this.selectedTaskChange = new EventEmitter<ITaskInfo>();
  }

  ngOnInit() {
    this.initDefaultFilter();

    this.userService.getCurrentUserOrg().then((res) => {
      this.organisationTypeId = res?.organisationTypeId;
      void this.bindERegions();
    });

    this.inboxjobsService.bindTaskTypes().then((res) => (this.taskTypes = res));

    this.refreshTasks();
    // let timer = TimerObservable.create(0, 30000);
    // this.subscription = timer.subscribe(t => {
    //     this.refreshTasks();
    // });
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: Number.MAX_SAFE_INTEGER / 2,
      sortField: '', // ASC
      sortOrder: 1,
      filters: {
        inboxType: { value: this._inboxType },
        from: {},
        to: {},
        taskType: { value: 0 },
        eregionId: { value: 0 },
        regNo: { value: null },
        taskStep: { value: null },
        taskStatusList: { value: null },
        customerId: { value: 0 },
        supplierId: { value: 0 },
        isMapMode: { value: true },
        isTrackingData: { value: true },
        eareaIdList: { value: null },
        eregionIdList: { value: null },
      },
    };
  }

  bindERegions() {
    if (this.organisationTypeId != 1) {
      return;
    }
    this.engineiusRegionService.getAll().then((res) => {
      if (res != null) {
        res.forEach((item) => {
          this.eregions.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  refreshTasks() {
    console.log(this.filterVal);
    this.taskService.GetLiveTasks(flatten(this.filterVal)).then((data) => {
      this.taskList = data.items;
    });
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    this.filterVal.filters.from.value = this.from;
    this.filterVal.filters.to.value = this.to;
    this.filterVal.filters.regNo.value = this.regNo;
    this.refreshTasks();
  }

  clearFilter() {
    this.initDefaultFilter();
    this.refreshTasks();
  }
}
